import type { FC } from 'react'
import type { CardFeatureProps } from '../atoms/CardFeature'
import { CardFeature } from '../atoms/CardFeature'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

export type FeatureCardBlockProps = {
	card: CardFeatureProps
}

const FeatureCardBlock: FC<FeatureCardBlockProps> = ({ card }) => {
	return (
		<ContentBlockWrapper blockTypes={['component', 'groupable', 'final']}>
			<div className="col-span-full">
				<CardFeature {...card} />
			</div>
		</ContentBlockWrapper>
	)
}

export default FeatureCardBlock
